import { Button, Modal, Spin } from "antd";
import React, { useContext } from "react";
import { useClient } from "../../Context/ClientContext";
import { Utils } from "../../../Utilities/Utils";
import "../../../CapsitechAccountsComponents/Pages/Assets/Css/Assets.css";
import { LoadingOutlined } from "@ant-design/icons";
import { notificationContext } from "../../Common/Routing/PageRoute";
import FixedAssetsServiceNew from "../../Services/FixedAssetsServiceNew";
import { dayjs } from "../../../Utilities/dayjs";
import ChartofAccountServicesNew from "../../Services/ChartofAccountServicesNew";
import LedgerService, {
  SearchLedgerByGroupsTypes,
} from "../../Services/LedgerService";
import { dep } from "./Depreciations/Depreciation";
import { ITCEligibilityTypeOptions } from "../../Services/VoucherServices";
import AssetLocationService from "../../Services/AssetLocationService";

interface Modelprops {
  isViewModelOpen: boolean;
  onCancel: any;
  assetId: {
    assetId: string;
    childAssetName: string;
  };
  type?: boolean;
}
const ViewAssetModel = ({
  isViewModelOpen,
  onCancel,
  assetId,
  type,
}: Modelprops) => {
  const { currentClient } = useClient();
  const { openNotification } = useContext(notificationContext);
  const [data, setData] = React.useState<any>({});
  const [loading, setLoading] = React.useState<boolean>(false);
  const [depreciable, setDepreciable] = React.useState<boolean>(false);
  const [fixedAssetsGroups, setFixedAssetsGroups] = React.useState<any>([]);
  const [fixedAssetsLocations, setFixedAssetsLocations] = React.useState<any>(
    []
  );
  const [payLedgers, setPayLedgers] = React.useState<any>([]);

  React?.useEffect(() => {
    setLoading(true);
    FixedAssetsServiceNew.getFixedAsset(
      currentClient?.id!,
      assetId.assetId,
      type
    )
      .then((res) => {
        if (res.status) {
          const ass = res?.result;
          setDepreciable(ass?.isDepreciable);
          let selInvoiceDetail = ass?.invoiceDetail?.find((inv: any) =>
            inv.childAssetDetail?.some(
              (child: any) => child.childAssetName === assetId.childAssetName
            )
          );
          let selChildAssetDetail = selInvoiceDetail.childAssetDetail?.find(
            (child: any) => child.childAssetName === assetId.childAssetName
          );
          const asset = {
            ...ass,
            invoiceDetail: {
              ...selInvoiceDetail,
              childAssetDetail: selChildAssetDetail,
            },
          };
          setData(asset);
          setLoading(false);
        } else setLoading(false);
      })
      .catch((ex) => {
        openNotification("error", ex.message);
        setLoading(false);
      });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [currentClient?.id]);
  console.log("Asset Data: ", data);

  React.useEffect(() => {
    //To get asset groups name
    const getGroupFixedAssets = async (clientId: String) => {
      if (clientId) {
        await ChartofAccountServicesNew.getGroupList(
          currentClient?.id!,
          currentClient?.productModule,
          "",
          "",
          "",
          "",
          SearchLedgerByGroupsTypes.FixedAssets
        )
          .then((res: any) => {
            if (res) {
              setFixedAssetsGroups(res?.items);
            }
          })
          .catch((err: any) => {
            console.error("error......", err?.message);
          });
      }

      LedgerService.getLedgersByGroupName(
        currentClient?.id!,
        SearchLedgerByGroupsTypes?.All
      ).then((res: any) => {
        setPayLedgers(res);
      });
    };
    getGroupFixedAssets(currentClient?.id!);

    //to get assets location name
    const getLocationFixedAssets = async (clientId: String) => {
      if (clientId) {
        await AssetLocationService.getLocationList(currentClient?.id!, 0, 0, "")
          .then((res: any) => {
            if (res) {
              setFixedAssetsLocations(res?.result);
            }
          })
          .catch((err: any) => {
            console.error("error......", err?.message);
          });
      }
    };
    getLocationFixedAssets(currentClient?.id!);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [currentClient?.id]);

  const getGroupLabel = (id: any) => {
    const group = fixedAssetsGroups?.find((group: any) => group?.id === id);
    return group ? group?.group_Name : id;
  };

  const getLedgerLabel = (id: any) => {
    const ledger = payLedgers?.find((ledger: any) => ledger?.id === id);
    return ledger ? ledger?.ledgerName : id;
  };
  const getLocationLabel = (id: any) => {
    const location = fixedAssetsLocations?.find(
      (location: any) => location?.id === id
    );
    return location ? location?.locationName : id;
  };

  const GetCategoryList = (DepList: any[]) => {
    return DepList?.map((itm: any) => {
      const list: any = {
        key: itm.Id,
        value: itm.Id,
        title: itm.Title,
      };
      if (itm.Children.length > 0) {
        list.children = GetCategoryList([...itm.Children]);
      }
      return list;
    });
  };
  const AssetCategoryOptions = GetCategoryList(dep);

  const categoryList = (CategoryOptions: any[], Id: any) => {
    const category: any = CategoryOptions?.map((catg: any) => {
      let res = "";
      if (catg?.key === Id) {
        res = catg?.title;
      } else {
        if (catg?.children?.length > 0) {
          res = categoryList(catg?.children, Id);
        }
      }
      return res;
    });
    return category ? category : Id;
  };

  return (
    <div>
      <Modal
        width={1000}
        title={"View Fixed Asset"}
        open={isViewModelOpen}
        onCancel={() => onCancel(false)}
        maskClosable={false}
        footer={
          <>
            <Button onClick={() => onCancel(false)}>Cancel</Button>
          </>
        }
        className="modelpadding"
      >
        <Spin
          indicator={<LoadingOutlined style={{ fontSize: 24 }} spin />}
          spinning={loading}
        >
          <div
            style={{ maxHeight: "65vh", overflowY: "auto", marginTop: "15px" }}
          >
            <table
              className="ca-viewmodel-table"
              style={{
                width: "100%",
                borderCollapse: "collapse",
                margin: "0px auto",
              }}
            >
              <tbody>
                {/* // Basic Detail */}
                <tr>
                  <td colSpan={4} align="left">
                    <strong>
                      <u>Asset Detail</u>
                    </strong>
                  </td>
                </tr>
                <tr>
                  <td style={{ width: "20%", background: "#f6f6f6" }}>
                    Asset Name
                  </td>
                  <td style={{ width: "30%" }}>
                    {data?.invoiceDetail?.childAssetDetail?.childAssetName}
                  </td>
                  <td style={{ width: "20%", background: "#f6f6f6" }}>
                    Asset Reference
                  </td>
                  <td style={{ width: "30%" }}>
                    {data?.invoiceDetail?.childAssetDetail?.childAssetNumber}
                  </td>
                </tr>
                <tr>
                  <td style={{ width: "20%", background: "#f6f6f6" }}>
                    Parent Asset Name
                  </td>
                  <td style={{ width: "30%" }}>{data?.name}</td>
                  <td style={{ width: "20%", background: "#f6f6f6" }}>
                    Parent Asset Reference
                  </td>
                  <td style={{ width: "30%" }}>{data?.number}</td>
                </tr>
                <tr>
                  <td style={{ width: "20%", background: "#f6f6f6" }}>
                    Identity No.
                  </td>
                  <td style={{ width: "30%" }}>
                    {data?.invoiceDetail?.childAssetDetail?.identityCode}
                  </td>

                  <td style={{ width: "20%", background: "#f6f6f6" }}>Model</td>
                  <td style={{ width: "30%" }}>
                    {data?.invoiceDetail?.childAssetDetail?.model}
                  </td>
                </tr>
                <tr>
                  <td style={{ width: "20%", background: "#f6f6f6" }}>
                    Assest Group
                  </td>
                  <td colSpan={3} style={{ width: "30%" }}>
                    {getGroupLabel(data?.group)}
                  </td>
                  {/* <td style={{ width: "20%", background: "#f6f6f6" }}>
                        Notes
                      </td>
                      <td style={{ width: "30%" }}>{data?.description}</td> */}
                </tr>
                <tr>
                  <td style={{ width: "20%", background: "#f6f6f6" }}>
                    Description
                  </td>
                  <td align="left" colSpan={3} style={{ width: "30%" }}>
                    {
                      data?.invoiceDetail?.childAssetDetail
                        ?.childAssetDescription
                    }
                  </td>
                </tr>
                {/* //Purchase Detail */}
                <tr>
                  <td colSpan={4} align="left">
                    <strong>
                      <u>Purchase Detail</u>
                    </strong>
                  </td>
                </tr>
                <tr>
                  <td style={{ width: "20%", background: "#f6f6f6" }}>
                    Purchase Date
                  </td>
                  <td style={{ width: "30%" }}>
                    {data?.invoiceDetail?.date &&
                      dayjs(data?.invoiceDetail?.date).format("DD/MM/YYYY")}
                  </td>

                  <td style={{ width: "20%", background: "#f6f6f6" }}>
                    Invoice No.
                  </td>
                  <td style={{ width: "30%" }}>
                    {data?.invoiceDetail?.invNumber}
                  </td>
                </tr>
                <tr>
                  <td style={{ width: "20%", background: "#f6f6f6" }}>
                    Tax Credit
                  </td>
                  <td style={{ width: "30%" }}>
                    {
                      ITCEligibilityTypeOptions.find(
                        (opt: any) =>
                          opt.value === data?.invoiceDetail?.taxCredit
                      )?.label
                    }
                  </td>

                  <td style={{ width: "20%", background: "#f6f6f6" }}>
                    Purchase Price
                  </td>
                  <td style={{ width: "30%" }}>
                    {Utils?.getFormattedNumber(
                      data?.invoiceDetail?.childAssetDetail?.price
                    )}
                  </td>
                </tr>
                <tr>
                  <td style={{ width: "20%", background: "#f6f6f6" }}>GST</td>
                  <td style={{ width: "30%" }}>
                    {data?.invoiceDetail?.gst?.name}
                  </td>

                  <td style={{ width: "20%", background: "#f6f6f6" }}>
                    Voucher Date
                  </td>
                  <td style={{ width: "30%" }}>
                    {data?.invoiceDetail?.voucherDate
                      ? dayjs(data?.invoiceDetail?.voucherDate).format(
                          "DD/MM/YYYY"
                        )
                      : dayjs(data?.invoiceDetail?.date).format("DD/MM/YYYY")}
                  </td>
                </tr>

                {/* //Payment Detail */}
                <tr>
                  <td colSpan={4} align="left">
                    <strong>
                      <u>Payment Given Detail</u>
                    </strong>
                  </td>
                </tr>
                <tr>
                  <td style={{ width: "20%", background: "#f6f6f6" }}>
                    Payment Mode
                  </td>
                  <td style={{ width: "30%" }}>
                    {data?.invoiceDetail?.purPayMethod === 0
                      ? "Bank"
                      : data?.invoiceDetail?.purPayMethod === 1
                      ? "Cash"
                      : data?.invoiceDetail?.purPayMethod === 2
                      ? "Credit"
                      : "Partially paid"}
                  </td>
                  <td style={{ width: "20%", background: "#f6f6f6" }}>
                    Payment Date
                  </td>
                  <td style={{ width: "30%" }}>
                    {data?.invoiceDetail?.purPayDate &&
                      dayjs(data?.invoiceDetail?.purPayDate).format(
                        "DD/MM/YYYY"
                      )}
                  </td>
                </tr>
                {(data?.invoiceDetail?.purPayMethod === 0 ||
                  data?.invoiceDetail?.purPayMethod === 1) && (
                  <tr>
                    <td style={{ width: "20%", background: "#f6f6f6" }}>
                      Payment Ledger
                    </td>
                    <td style={{ width: "30%" }}>
                      {getLedgerLabel(data?.invoiceDetail?.purPaymentLedger)}
                    </td>
                    <td style={{ width: "20%", background: "#f6f6f6" }}>
                      Payment Reference
                    </td>
                    <td style={{ width: "30%" }}>
                      {data?.invoiceDetail?.purPayRef}
                    </td>
                  </tr>
                )}
                {data?.invoiceDetail?.purPayMethod === 2 && (
                  <tr>
                    <td style={{ width: "20%", background: "#f6f6f6" }}>
                      Party Ledger
                    </td>
                    <td style={{ width: "30%" }} colSpan={3}>
                      {getLedgerLabel(data?.invoiceDetail?.purPartyLedger)}
                    </td>
                    {/* <td style={{ width: "20%", background: "#f6f6f6" }}>
                          Payment Reference
                        </td>
                        <td style={{ width: "30%" }}>
                          {data?.invoiceDetail?.purPayRef}
                        </td> */}
                  </tr>
                )}
                {data?.invoiceDetail?.purPayMethod === 3 && (
                  <>
                    <tr>
                      <td style={{ width: "20%", background: "#f6f6f6" }}>
                        Payment Ledger
                      </td>
                      <td style={{ width: "30%" }}>
                        {getLedgerLabel(data?.invoiceDetail?.purPaymentLedger)}
                      </td>
                      <td style={{ width: "20%", background: "#f6f6f6" }}>
                        Payment Reference
                      </td>
                      <td style={{ width: "30%" }}>
                        {data?.invoiceDetail?.purPayRef}
                      </td>
                    </tr>
                    <tr>
                      <td style={{ width: "20%", background: "#f6f6f6" }}>
                        Paid Amount
                      </td>
                      <td style={{ width: "30%" }}>
                        {data?.invoiceDetail?.partiallyPaidAmount}
                      </td>
                      <td style={{ width: "20%", background: "#f6f6f6" }}>
                        Party Ledger
                      </td>
                      <td style={{ width: "30%" }}>
                        {getLedgerLabel(data?.invoiceDetail?.purPartyLedger)}
                      </td>
                    </tr>
                  </>
                )}

                {/* //Depreciation Detail */}
                {depreciable && (
                  <>
                    <tr>
                      <td colSpan={4} align="left">
                        <strong>
                          <u>Depreciation Detail</u>
                        </strong>
                      </td>
                    </tr>
                    <tr>
                      <td style={{ width: "20%", background: "#f6f6f6" }}>
                        Asset Category
                      </td>
                      <td style={{ width: "30%" }} colSpan={4}>
                        {categoryList(AssetCategoryOptions, data?.category)}
                      </td>
                    </tr>
                    <tr>
                      <td style={{ width: "20%", background: "#f6f6f6" }}>
                        Depreciation Method
                      </td>
                      <td style={{ width: "30%" }}>
                        {data?.depMethod === 1
                          ? "Straight Line Method"
                          : "Written Down Method"}
                      </td>

                      <td style={{ width: "20%", background: "#f6f6f6" }}>
                        Asset Life in year
                      </td>
                      <td style={{ width: "30%" }}>
                        {data?.lifeCycleDuration}
                      </td>
                    </tr>
                    <tr>
                      <td style={{ width: "20%", background: "#f6f6f6" }}>
                        Depreciation Rate
                      </td>
                      <td style={{ width: "30%" }}>{data?.depRate}</td>

                      <td style={{ width: "20%", background: "#f6f6f6" }}>
                        Depreciation Start Date
                      </td>
                      <td style={{ width: "30%" }}>
                        {data?.invoiceDetail?.childAssetDetail
                          ?.depreciationStartDate &&
                          dayjs(
                            data?.invoiceDetail?.childAssetDetail
                              ?.depreciationStartDate
                          ).format("DD/MM/YYYY")}
                      </td>
                    </tr>
                  </>
                )}

                {/* //Other Detail */}
                <tr>
                  <td colSpan={4} align="left">
                    <strong>
                      <u>Other Detail</u>
                    </strong>
                  </td>
                </tr>
                <tr>
                  <td style={{ width: "20%", background: "#f6f6f6" }}>
                    Asset Location
                  </td>
                  <td style={{ width: "30%" }}>
                    {getLocationLabel(
                      data?.invoiceDetail?.childAssetDetail?.location
                    )}
                  </td>

                  <td style={{ width: "20%", background: "#f6f6f6" }}>
                    Residual Value of Asset
                  </td>
                  <td style={{ width: "30%" }}>
                    {Utils?.getFormattedNumber(
                      data?.invoiceDetail?.childAssetDetail?.residualValue
                    )}
                  </td>
                </tr>
                <tr>
                  <td style={{ width: "20%", background: "#f6f6f6" }}>
                    Warranty / Guarantee Expiry Date
                  </td>
                  <td align="left" colSpan={3} style={{ width: "30%" }}>
                    {data?.invoiceDetail?.childAssetDetail?.warrantyExpDate &&
                      dayjs(
                        data?.invoiceDetail?.childAssetDetail?.warrantyExpDate
                      ).format("DD/MM/YYYY")}
                  </td>
                </tr>

                {/* //Disposed Detail */}
                {type === true && (
                  <>
                    <tr>
                      <td colSpan={4} align="left">
                        <strong>
                          <u>Disposed Details</u>
                        </strong>
                      </td>
                    </tr>

                    <tr>
                      <td style={{ width: "20%", background: "#f6f6f6" }}>
                        Payment Mode
                      </td>
                      <td style={{ width: "30%" }}>
                        {data?.invoiceDetail?.childAssetDetail
                          ?.disposalPaymentMethod === 0
                          ? "Bank"
                          : data?.invoiceDetail?.childAssetDetail
                              ?.disposalPaymentMethod === 1
                          ? "Cash"
                          : data?.invoiceDetail?.childAssetDetail
                              ?.disposalPaymentMethod === 2
                          ? "Credit"
                          : "Partially paid"}
                      </td>
                      <td style={{ width: "20%", background: "#f6f6f6" }}>
                        Disposal Date
                      </td>
                      <td style={{ width: "30%" }}>
                        {data?.invoiceDetail?.childAssetDetail?.disposalDate &&
                          dayjs(
                            data?.invoiceDetail?.childAssetDetail?.disposalDate
                          ).format("DD/MM/YYYY")}
                      </td>
                    </tr>

                    <tr>
                      <td style={{ width: "20%", background: "#f6f6f6" }}>
                        Disposal Value
                      </td>
                      <td align="left" style={{ width: "30%" }}>
                        {Utils?.getFormattedNumber(
                          data?.invoiceDetail?.childAssetDetail?.disposalValue
                        )}
                      </td>
                      {data?.invoiceDetail?.childAssetDetail
                        ?.disposalPaymentMethod === 2 && (
                        <>
                          <td style={{ width: "20%", background: "#f6f6f6" }}>
                            Disposal Party Ledger
                          </td>
                          <td style={{ width: "30%" }} colSpan={3}>
                            {getLedgerLabel(
                              data?.invoiceDetail?.childAssetDetail
                                ?.disposalPartyLedger
                            )}
                          </td>
                        </>
                      )}
                      {data?.invoiceDetail?.childAssetDetail
                        ?.disposalPaymentMethod !== 2 && (
                        <>
                          <td style={{ width: "20%", background: "#f6f6f6" }}>
                            Pay Date
                          </td>
                          <td style={{ width: "30%" }}>
                            {data?.invoiceDetail?.childAssetDetail
                              ?.disposalPayDate &&
                              dayjs(
                                data?.invoiceDetail?.childAssetDetail
                                  ?.disposalPayDate
                              ).format("DD/MM/YYYY")}
                          </td>
                        </>
                      )}
                    </tr>
                    {(data?.invoiceDetail?.childAssetDetail
                      ?.disposalPaymentMethod === 0 ||
                      data?.invoiceDetail?.childAssetDetail
                        ?.disposalPaymentMethod === 1) && (
                      <tr>
                        <td style={{ width: "20%", background: "#f6f6f6" }}>
                          Disposal Payment Ledger
                        </td>
                        <td style={{ width: "30%" }}>
                          {getLedgerLabel(
                            data?.invoiceDetail?.childAssetDetail
                              ?.disposalPaymentLedger
                          )}
                        </td>
                        <td style={{ width: "20%", background: "#f6f6f6" }}>
                          Disposal Payment Ref.
                        </td>
                        <td style={{ width: "30%" }}>
                          {
                            data?.invoiceDetail?.childAssetDetail
                              ?.disposalPaymentRef
                          }
                        </td>
                      </tr>
                    )}
                    {data?.invoiceDetail?.childAssetDetail
                      ?.disposalPaymentMethod === 3 && (
                      <>
                        <tr>
                          <td style={{ width: "20%", background: "#f6f6f6" }}>
                            Disposal Payment Ledger
                          </td>
                          <td style={{ width: "30%" }}>
                            {getLedgerLabel(
                              data?.invoiceDetail?.childAssetDetail
                                ?.disposalPaymentLedger
                            )}
                          </td>
                          <td style={{ width: "20%", background: "#f6f6f6" }}>
                            Disposal Payment Ref.
                          </td>
                          <td style={{ width: "30%" }}>
                            {
                              data?.invoiceDetail?.childAssetDetail
                                ?.disposalPaymentRef
                            }
                          </td>
                        </tr>
                        <tr>
                          <td style={{ width: "20%", background: "#f6f6f6" }}>
                            Disposal Paid Amount
                          </td>
                          <td style={{ width: "30%" }}>
                            {
                              data?.invoiceDetail?.childAssetDetail
                                ?.partiallyPaidAmount
                            }
                          </td>
                          <td style={{ width: "20%", background: "#f6f6f6" }}>
                            Disposal Party Ledger
                          </td>
                          <td style={{ width: "30%" }}>
                            {getLedgerLabel(
                              data?.invoiceDetail?.childAssetDetail
                                ?.disposalPartyLedger
                            )}
                          </td>
                        </tr>
                      </>
                    )}
                  </>
                )}
              </tbody>
            </table>
          </div>
        </Spin>
      </Modal>
    </div>
  );
};

export default ViewAssetModel;
